module.exports = __webpack_public_path__ + "media/images/ios-share-060ed4a3545579e9c1e5cbb32b7d7482.png";